import { alpha } from '@material-ui/core/styles'

// ----------------------------------------------------------------------
// Methylation colour tokens (theme.palette.methylation). One source for the
// dashboard tables, charts and filters so the view stops carrying its own hex.
//
//   ramp       sequential, ONE hue (violet): methylation 0..100 % maps to fill
//              strength, never to a different hue. High methylation is not
//              "bad", so no severity colours.
//   mod        5mC / 5hmC identity (only one is shown at a time).
//   haplotype  the two phase lanes in charts. Reference categorical slots 1
//              and 2 (blue, orange), validated as a pair in both modes; h2 is
//              also drawn dashed so the lanes differ without colour.
//              Haplotype 1/2 are phase labels, never mother/father.
//   combined   neutral ink for the both-alleles trace.
//   track      low / high ends of the canvas dot ramp (unified track).
//
// Each tone carries { main, text, bg }: `main` for marks, `text` for words on
// paper (readable in the mode), `bg` a tinted fill for pills.

const tone = (main, text, isLight) => ({ main, text, bg: alpha(main, isLight ? 0.12 : 0.18) })

export const createMethylation = (isLight) => {
  const violetMain = isLight ? '#5F66A8' : '#9A9FD0'
  const violetText = isLight ? '#3F4482' : '#C3C6E6'
  return {
    ramp: { main: violetMain, text: violetText, minFill: isLight ? 0.06 : 0.08, maxFill: isLight ? 0.32 : 0.35 },
    mod: {
      '5mc': tone(violetMain, violetText, isLight),
      '5hmc': tone(isLight ? '#B26A00' : '#E0A526', isLight ? '#8A5200' : '#EDC766', isLight),
    },
    haplotype: {
      h1: tone(isLight ? '#2A78D6' : '#3987E5', isLight ? '#1F5FAD' : '#8DB8EE', isLight),
      h2: tone(isLight ? '#EB6834' : '#D95926', isLight ? '#B24718' : '#F0A07E', isLight),
    },
    combined: isLight ? '#383D45' : '#B3BCC7',
    // Canvas dots on the unified track: the same violet, light to dark on
    // paper and dark to light on the night surface, so 100% always has the
    // most contrast against the background.
    track: isLight ? { low: '#C3C6E6', high: '#33366A' } : { low: '#4F5490', high: '#E6E7F4' },
  }
}

// Fill and text for a methylation percentage on the one-hue ramp.
export const methRampStyle = (methylation, pct) => {
  const { ramp } = methylation
  if (!Number.isFinite(pct)) return { color: 'text.secondary', backgroundColor: 'transparent' }
  const t = Math.max(0, Math.min(100, pct)) / 100
  return {
    color: ramp.text,
    backgroundColor: alpha(ramp.main, ramp.minFill + (ramp.maxFill - ramp.minFill) * t),
  }
}
